const langButtonHeader = document.querySelector('.header__lang-button')
const langButtonFooter = document.querySelector('.footer__lang-button')
if (langButtonHeader) {
  const langList = document.querySelector('.header__lang-list')
  const arrowElementButton = document.querySelector('.header__lang-arrow')
  langButtonHeader.addEventListener('click', () => {
    if (langList) {
      langButtonHeader.classList.toggle('header__lang-button_open')
      langList.classList.toggle('header__lang-list_open')
      arrowElementButton.classList.toggle('header__lang-arrow_rotate')
    }
  })
}
if (langButtonFooter) {
  const langList = document.querySelector('.footer__lang-list')
  const arrowElementButton = document.querySelector('.footer__lang-arrow')
  langButtonFooter.addEventListener('click', () => {
    if (langList) {
      langButtonFooter.classList.toggle('footer__lang-button_open')
      langList.classList.toggle('footer__lang-list_open')
      arrowElementButton.classList.toggle('footer__lang-arrow_rotate')
    }
  })
}

const menuButtonBurger = document.querySelector('.header__btn-burger')
if (menuButtonBurger) {
  const menuButtonClose = document.querySelector('.header__btn-close')
  const menu = document.querySelector('.header__links')

  function toggleMobileMenu() {
    menu.classList.toggle('header__links_open')
    menuButtonBurger.classList.toggle('header__btn-burger_disable')
    menuButtonClose.classList.toggle('header__btn-close_enable')
  }

  menuButtonBurger.addEventListener('click', () => {
    toggleMobileMenu()
  })

  menuButtonClose.addEventListener('click', () => {
    toggleMobileMenu()
  })
}
